import { render } from "./AppLoading.vue?vue&type=template&id=cae31b52"
import script from "./AppLoading.vue?vue&type=script&lang=js"
export * from "./AppLoading.vue?vue&type=script&lang=js"

import "./AppLoading.vue?vue&type=style&index=0&id=cae31b52&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.19.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__